// store.js
import { reactive } from 'vue';

export const store = reactive({

	/* 过滤的渠道号。如果是以下这些渠道号，就不显示
	1.顶部的域名广告通知，
	2.顶部的保存网址
	3.底部的广告 Footer
	*/
	filterQudaolist: [
		'haijiao-xpj', 
		'haijiao-pg',
		'haijiao-yinhe',
		'haijiao51zhibo',
		'haijiao-xiangfei',
		'haijiao-xingba',
		'haijiao-kaiyuan',
		'haijiao77',
		'haijiao-xpj01',
		'haijiao-aizhibo'
	],
	config: {},
	adsList: [],
	adsIdConfig: {
		'/home': '1,5,6,11,12',
		'/details': '1,3,4,6,9,11,13',
		'/more': '1,6,11',
		'/search': '6,11'
	},
	setConfig: (config) => {
		store.config = config;
	},
	setAdsList: (value) => {
		value.forEach((v) => {
			if (store.isDev()) {
				// v.icon = require('@/assets/logo.png')
				v.name = 'name';
			}
		});
		store.adsList = value;
	},
	isDev: () => {
		// return process.env.NODE_ENV === "development"
		return false;
	},
	homeIndexCurrent: 1,
	setHomeIndexCurrent: (value) => {
		store.homeIndexCurrent = value;
	}
});
